// This is a code that supports toggling longer text blocks.
//
// It expects following HTML:
//  <div>Content that is ... <a href="#" class="show-more">Show more</a></div>
//  <div style="display:none">Content that is shortened and will be revealed after clicking to "Show more" link. <a href="#" class="show-less">Show less</a></div>

document.addEventListener('turbo:load', () => {
  document.querySelectorAll('.show-more').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();

      link.parentElement.style.display = 'none';
      link.parentElement.nextSibling.style.display = 'block';
    });
  });

  document.querySelectorAll('.show-less').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();

      link.parentElement.style.display = 'none';
      link.parentElement.previousSibling.style.display = 'block';
    });
  });
});
